import { gql } from "@stadium/services/apollo-client";

export const fetchUser = gql`
  query User @api(name: "users") {
    currentUser {
      id
      spreeId
      email
      firstName
      lastName
      ldUserKey
      ldSecureModeHash
      phone
      companyName
      countryName
      walletBalance
      walletCurrency {
        id
        name
        code
        symbol
      }
    }
  }
`;
